import api from "../../api";

/**
 * Controls who may open Insights → Pricing Reports.
 * When REACT_APP_PRICING_REPORTS_ROLE_IDS is unset, any authenticated partner session may view (still behind Authenticated).
 */
export function canViewPricingReports(user) {
  const raw = process.env.REACT_APP_PRICING_REPORTS_ROLE_IDS;
  if (!raw || !String(raw).trim()) {
    return true;
  }
  if (api.isAdmin(user)) {
    return true;
  }
  const ids = String(raw)
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
  return ids.includes(user?.role);
}
